import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=2d69fa5d&scoped=true&"
import script from "./MyDialog.vue?vue&type=script&lang=js&"
export * from "./MyDialog.vue?vue&type=script&lang=js&"
import style0 from "./MyDialog.vue?vue&type=style&index=0&id=2d69fa5d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d69fa5d",
  null
  
)

export default component.exports